import { inject, Injectable } from '@angular/core';
import { Observable } from "rxjs";
import { ApiService } from "./api.service";

@Injectable({
  providedIn: 'root'
})
export class TeamService {
  private _apiService: ApiService = inject(ApiService);

  constructor() { }

  getSportTypes(): Observable<any> {
    return this._apiService.get('/teams/sports/', undefined, true);
  }

  getTeam(id: string): Observable<any> {
    return this._apiService.get(`/teams/${id}/`, undefined, true);
  }
}
